import { Box, styled } from '@zenchef/styled-system/jsx'

const TableBox = styled(Box, {
  base: {
    borderWidth: 'm',
    borderStyle: 'solid',
    borderColor: 'border.neutral.subtle',
    borderRadius: 'l',
    mb: 'margin.4'
  }
})

export default TableBox
